import React from "react";

import {
    Row,
    Col,
    Tabs,
} from 'antd';
import { UserOutlined, BookOutlined, RiseOutlined } from '@ant-design/icons';

import './search_page.css';

import {
    RsrSearchBlock,
    PubSearchBlock,
    GsPubSearchBlock,
    SmtPubSearchBlock,
    AltTrendingSearchBlock,
} from "./components/SearchBlock"

import {
    RsrFilterBlock,
    PubFilterBlock,
    GsPubFilterBlock,
    SmtPubFilterBlock,
    AltTrendingFilterBlock
} from "./components/FilterBlock"

import {
    RsrTabBlock,
    PubTabBlock,
    GsPubTabBlock,
    SmtPubTabBlock,
    AltTrendingTabBlock
} from "./components/TabBlock";

import CreationTabBlock from './components/TabBlock/CreationTab'
import CreationSearchBlock from "./components/SearchBlock/CreationSearchBlock";
import CreationFilterBlock from "./components/FilterBlock/CreationFilterBlock";

import searchPgUserInputsS from "./UserInputsSlice";
import { RootState, SearchTab } from "utils/types";
import { useDispatch, useSelector } from "react-redux";


export default () => {
    const dispatch = useDispatch();
    const { searchTab } = useSelector((state: RootState) => state.searchPgUserInputs);

    return <>
        <Row gutter={{ xs: 2, sm: 4, lg: 0 }} justify="start">
            <Col
                xs={{ span: 24 }}
                sm={{ span: 12 }}
                lg={{ span: 11, offset: 0 }}
                xxl={{ span: 8, offset: 3 }}
            >
                {searchTab === SearchTab.RESEARCHERS && <RsrSearchBlock />}
                {searchTab === SearchTab.PUBLICATIONS && <PubSearchBlock />}
                {searchTab === SearchTab.GS_PUBLICATIONS && <GsPubSearchBlock />}
                {searchTab === SearchTab.SMT_PUBLICATIONS && <SmtPubSearchBlock />}
                {searchTab === SearchTab.TRENDING && <AltTrendingSearchBlock />}
                {searchTab === SearchTab.RESEARCH_CREATION && <CreationSearchBlock />}
            </Col>

            <Col
                xs={{ span: 24 }}
                sm={{ span: 12 }}
                lg={{ span: 11, offset: 2 }}
                xxl={{ span: 8, offset: 2 }}
            >
                {searchTab === SearchTab.RESEARCHERS && <RsrFilterBlock />}
                {searchTab === SearchTab.PUBLICATIONS && <PubFilterBlock />}
                {searchTab === SearchTab.GS_PUBLICATIONS && <GsPubFilterBlock />}
                {searchTab === SearchTab.SMT_PUBLICATIONS && <SmtPubFilterBlock />}
                {searchTab === SearchTab.TRENDING && <AltTrendingFilterBlock />}
                {searchTab === SearchTab.RESEARCH_CREATION && <CreationFilterBlock />}
            </Col>

        </Row>

        <Tabs 
            activeKey={searchTab}
            onChange={(key: string) => {
                dispatch(searchPgUserInputsS.actions.setSearchTab(key as SearchTab));
            }}
        >
            <Tabs.TabPane
                tab={<span className="sub-heading-font"><UserOutlined style={{marginRight: '0.2em'}}/>Researchers</span>}
                key={SearchTab.RESEARCHERS}
            >
                <RsrTabBlock/>
            </Tabs.TabPane>

            <Tabs.TabPane
                tab={<span className="sub-heading-font"><BookOutlined style={{marginRight: '0.2em'}}/>Scopus Publications</span>}
                key={SearchTab.PUBLICATIONS}
            >
                <PubTabBlock/>
            </Tabs.TabPane>

            <Tabs.TabPane
                tab={<span className="sub-heading-font"><BookOutlined style={{marginRight: '0.2em'}}/>Google Scholar</span>}
                key={SearchTab.GS_PUBLICATIONS}
            >
                <GsPubTabBlock/>
            </Tabs.TabPane>

            <Tabs.TabPane
                tab={<span className="sub-heading-font"><BookOutlined style={{marginRight: '0.2em'}}/>SFU Summit</span>}
                key={SearchTab.SMT_PUBLICATIONS}
            >
                <SmtPubTabBlock/>
            </Tabs.TabPane>

            <Tabs.TabPane
                tab={<span className="sub-heading-font"><RiseOutlined style={{marginRight: '0.2em'}}/>Trending</span>}
                key={SearchTab.TRENDING}
            >
                <AltTrendingTabBlock/>
            </Tabs.TabPane>

            <Tabs.TabPane
                tab={<span className="sub-heading-font"><BookOutlined style={{marginRight: '0.2em'}}/>Research Creation</span>}
                key={SearchTab.RESEARCH_CREATION}
            >
                <CreationTabBlock />
            </Tabs.TabPane>
        </Tabs>
    </>;
}

